import React, { useState } from "react";
import Card from "../../components/Cards/Card";
import { skillsDatabase } from "./skillsDb";
import { Skills } from "./styles";

const SkillList = () => {
	const [skill] = useState(skillsDatabase);

	return (
		<Skills>
			{skill.map((sk) => (
				<Card
					key={sk.name}
					name={sk.name}
					percent={sk.progress}
					icon={sk.icon}
				/>
			))}
		</Skills>
	);
};

export default SkillList;
